import { createTheme, lighten } from "@mui/material";

declare module "@mui/material/styles" {
  interface Palette {
    teal: {
      [key: number]: string; // allows 100, 200, 300...
      main: string;
      light?: string;
      dark?: string;
      contrastText?: string;
    };
  }
  interface PaletteOptions {
    teal?: {
      [key: number]: string; // allows 100, 200, 300...
      main: string;
      light?: string;
      dark?: string;
      contrastText?: string;
    };
  }
}

declare module "@mui/material/Button" {
  interface ButtonPropsColorOverrides {
    teal: true;
  }
}

declare module "@mui/material/TableRow" {
  interface TableRowPropsVariantOverrrides {
    card?: true;
  }
}

declare module "@mui/material/Button" {
  interface ButtonPropsVariantOverrides {
    secondary: true;
    alternate: true;
  }
}

export const theme = createTheme({
  components: {
    MuiButton: {
      defaultProps: {
        variant: "contained",
        color: "primary",
      },
      styleOverrides: {
        root: {
          textTransform: "none",
          fontSize: "1rem",
          fontWeight: 600,
          borderRadius: "8px",
        },
        contained: ({ ownerState }) => ({
          ...(ownerState.color === "primary" && {
            "&:hover": {
              backgroundColor: "#26c0c3",
            },
          }),
        }),
      },
      variants: [
        {
          props: { variant: "secondary" },
          style: {
            backgroundColor: "#FF8175",
            color: "#ffffff",
            "&:hover": {
              backgroundColor: lighten("#FF8175", 0.1),
            },
          },
        },
        {
          props: { variant: "alternate" },
          style: {
            backgroundColor: "#FAFAFA",
            "&:hover": {
              backgroundColor: lighten("#8D8D8D", 0.8),
            },
          },
        },
      ],
    },
    MuiTableRow: {
      variants: [
        {
          props: { "aria-label": "task row" },
          style: ({ theme }) => ({
            backgroundColor: theme.palette.background.paper,
            border: `1px solid rgba(86,144,153,0.4)`,
            borderRadius: 4,
            position: "relative",
            zIndex: 1,
          }),
        },
      ],
    },
  },
  palette: {
    teal: {
      100: "#E0F7F8",
      200: "#B3ECEE",
      300: "#80E0E3",
      400: "#4DD6D9",
      500: "#00B6B9", // main
      600: "#009EA0",
      700: "#008587",
      800: "#006D6F",
      900: "#004D4F",
      main: "#00B6B9",
    },
    text: {
      primary: "#15202b",
    },
    primary: {
      main: "#00B6B9",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#FF8175",
      light: "#FFD1CD",
      dark: "#CC5248",
    },
    info: {
      main: "#15202b",
    },
  },
  typography: {
    fontFamily: "Plus Jakarta Sans, sans-serif",
    subtitle1: {
      color: "#6C7278",
    },
    subtitle2: {
      color: "#6C7278",
    },
  },
});
